import React, { useState, useEffect } from 'react';
import { PHP_API } from '../../../../../utils/Common';
import axios from "axios";
import { getDate } from "../../../../../utils/DateFunctions.jsx"
import { getUser } from '../../../../../utils/Common';
import { quitarAcentos } from '../../../../sharecomponents/ExcelUtilities.jsx';
import Tabla_aclimatacion_vivero_campo from './Tabla_aclimatacion_vivero_campo.js';
import historial from '../../../../../assets/history.png';
import HistorialEstados from '../../../../sharecomponents/HistorialEstados.js';

const Reporte_aclimatacion_consolidacion = (p) => {
    useEffect(() => {

    }, []);
    const dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const [sending, setsending] = useState(false);
    const [registros_realizados, setregistros_realizados] = useState({});
    const [showHistory, setshowHistory] = useState(false);
    const [loader, setloader] = useState(false);
    const [history, sethistory] = useState([]);
    const [idDetalles, setidDetalles] = useState();

    const mostrarHistorial = (history) => {
        setshowHistory(true);
        sethistory([...history])
        //abrirHistorial(id);
    }

    const abrirHistorial = (id) => {
        setloader(true);
        axios.post(`${PHP_API}HistorialEstatusvivero`, { id: id, estatus: 2 }).then((resp) => {
            setloader(false);
            sethistory([...resp.data]);
            setshowHistory(true);
        }).catch((e) => { setloader(false) })

    }

    const mostrar_ocultar_detalles = (id) => {
        if (!id || idDetalles == id) setidDetalles(-1);
        else setidDetalles(id);
    }

    const cehck = (index, type) => {
        let dt = [...p.data];
        let original = { ...dt[index] };
        let user_id = getUser().id;
        let dataSend = { id: p.data[index].plan_id, action: 'update', tipo: type, user: user_id };

        if (type === 'aclimatacion') {
            dt[index].usuario_acl = user_id;
            dt[index].aclimatado = dt[index].aclimatado ? null : getDate();

        }
        else {
            dt[index].usuario_con = user_id;
            dt[index].consolidado = dt[index].consolidado ? null : getDate();
        }

        p.setData(dt);
        axios
            .post(PHP_API + "plan_aclimatacion", dataSend)
            .then((r) => {

                if (r.data && !r.data.estatus) {
                    dt = [...p.data];
                    dt[index] = original;
                    p.setData(dt);
                }
            })
            .catch((e) => {
                dt = [...p.data];
                dt[index] = original;
                p.setData(dt);
            });
    }

    const addInfo = (event, index, type, day) => {
        let dt = [...p.data];
        let original = { ...dt[index] };
        let user_id = getUser().id;
        let dataSend = {
            id: p.data[index].plan_id,
            action: 'update',
            tipo: type,
            user: user_id,
            day: day
        };

        dt[index][`${dias[day]}${type}`] = event.target.value === '' ? 0 : +event.target.value;
        dataSend.value = dt[index][`${dias[day]}${type}`];
        p.setData(dt);
        axios
            .post(PHP_API + "plan_aclimatacion", dataSend)
            .then((r) => {

                if (r.data && !r.data.estatus) {
                    dt = [...p.data];
                    dt[index] = original;
                    p.setData(dt);
                }
            })
            .catch((e) => {
                dt = [...p.data];
                dt[index] = original;
                p.setData(dt);
            });
    }

    const totales_bloque = (dt) => {
        let total_plan = 0;
        let total_ejecutado = 0;
        for (let i = 0; i < dias.length; i++) {
            total_plan += dt[`${dias[i]}p`];
            total_ejecutado += dt[`${dias[i]}e`];
        }
        return (
            <div className='row justify-content-evenly m-0 p-0 text-m w-100 mt-2' style={{ width: p.type !== 'aclimatacion' ? '250px' : '320px' }}>
                <div className={'m-0 p-0 text-center ' + (p.type !== 'aclimatacion' ? 'w-60' : 'w-50')} style={{ borderRight: "solid black 1px" }}>
                    {total_plan} <span className='text-xs'>ch</span>
                    {separador()}
                    <span className='text-s'>{dt.germinacion_plan}% <span className='text-xs'>{dt.germinacion_real === "0.00" ? "GM programa" : 'GM DDS'}</span></span>
                </div>
                <div className={'m-0 p-0 text-center ' + (p.type !== 'aclimatacion' ? 'w-40' : 'w-50')}>
                    {total_ejecutado} <span className='text-xs'>ch</span>

                    {p.type !== 'aclimatacion' ? '' : (<>{separador()}<span className={`text-s ${+dt.germinacion_consolidacion === 0 ? 'opacity-50' : ''}`}>{dt.germinacion_consolidacion}%</span> <span className='text-xs'>GM cons.</span></>)}
                </div>
            </div>
        )
    }

    const total_ejecutado = (dt) => {
        let total = 0;
        for (let i = 0; i < dias.length; i++) {
            total += dt[`${dias[i]}e`];
        }
        return total;
    }

    const cambiarGermiancion = (i, valor) => {
        if (sending) return;
        setsending(true);
        let respaldo = { ...p.data[i] };
        let listData = [...p.data];

        let germinacion = parseFloat(valor);
        if (isNaN(germinacion)) germinacion = 0;
        else if (germinacion > 10000) germinacion = germinacion / 100000;
        else if (germinacion > 1000) germinacion = germinacion / 10000;
        else if (germinacion > 100) germinacion = germinacion / 1000;
        else if (germinacion > 10) germinacion = germinacion / 100;
        else if (germinacion > 1) germinacion = germinacion / 10;

        if (`${germinacion}`.length > 8) germinacion = +germinacion.toFixed(3);

        listData[i].germinacion_consolidacion = germinacion;
        p.setData(listData);

        let dataSend = { id: respaldo.plan_id, germinacion_envio: germinacion };
        axios
            .post(PHP_API + "setGerminacion", dataSend)
            .then((r) => {
                if (!r.data.estatus) {
                    listData[i] = respaldo;
                    p.setData(listData);
                } setsending(false);
            })
            .catch((e) => console.log(e));
    }

    //Actualiza la lista de valores que se enviaran al reporte de consolidación ejecutados
    const agregar_cambio_ejecutado = (index, day, value) => {
        value = parseFloat(value);
        if (isNaN(value) || value < 0) value = 0;


        let realizados = { ...registros_realizados };
        if (!realizados[index + day]) {
            realizados[index + day] = {
                index: index,
                key: day,
                plan: p.data[index].plan_id,
                dia: quitarAcentos(day.slice(0, -1)),
                value: p.data[index][day]
            };
            setregistros_realizados(realizados);
        }
        let dt = [...p.data];
        dt[index][day] = value;
        p.setData(dt);

        //plan_aclimatacion_reporte
    }

    const restaurar_valores = () => {
        let dt = [...p.data];
        let changes = Object.values(registros_realizados);
        changes.forEach(ch => { dt[ch.index][ch.key] = ch.value; });
        p.setData(dt);
        setregistros_realizados({});
    }

    const aplicar_ejecucion = () => {
        let list_cambios = [];
        let changes = Object.values(registros_realizados);
        changes.forEach(ch => {
            list_cambios.push({
                plan: ch.plan,
                cantidad: p.data[ch.index][ch.key],
                dia: ch.dia.toLowerCase()
            });
        });


        p.loader(true);
        axios
            .post(PHP_API + "plan_aclimatacion_reporte", { usuario: getUser().id, cambios: list_cambios })
            .then((r) => {
                p.loader(false);
                console.log(r, r.data, r.data.estatus, r.data.msj);
                if (r && r.data && r.data.estatus) {
                    p.api();
                    setregistros_realizados({});
                } else {
                    p.dialog('Ocurrió un problema', r.data.msj);
                }
            })
            .catch((e) => p.loader(false));
    }

    /**
     * Retorna las diferencias en semanas entre la semana de siembra planeada y la semana de ejecución
     * @param {object} p - un elemento del plan de siembra de la lista alojada en data
     * @returns {number} numero de semanas de diferencia respecto a semana de siembra planeada
     */
    const diferencia = (p) => {
        if (p.semana_ejecucion && p.fecha_inicio) {
            let inicio = new Date(p.fecha_inicio);
            let ejecucion = new Date(p.fecha_semana_ejecucion);

            let diferencia = ejecucion - inicio;
            let dias = diferencia / (1000 * 60 * 60 * 24);
            let semanas = dias / 7;
            return Math.floor(semanas);
        }
        return 0;
    }

    const separador = () => { return (<span className="ms-2 me-2 text-900" style={{ color: "#BBBBBB" }}>|</span>) }
    return (
        <div className='w-100 mandatory-child p-0 round-bottom-xl overflow' style={{ maxHeight: '80vh' }}>
            {Object.keys(registros_realizados).length > 0 && <div className='col-auto'>
                <div className='row justify-content-evenly bw-350 m-0 p-0 m-0 p-3 bg-white4 blur-s round-top-l border  border-secondary shadow-multi' style={{ position: 'fixed', bottom: 0, left: 0, zIndex: 10 }}>
                    <button className='btn btn-warning text-bold scale-continue-05 border border-3 border-dark shadow-multi bw-150 round-l' onClick={aplicar_ejecucion} >Guardar cambios</button>
                    <button className='btn btn-light text-bold scale-05 border border-3 border-warning shadow-multi bw-150 text-s round-l' onClick={restaurar_valores}  >Restaurar valores</button>
                </div>
            </div>}
            {p.type === 'aclimatacion' && <Tabla_aclimatacion_vivero_campo data={p.data} check={cehck} />}
            {p.type !== 'aclimatacion' && <table className='table table-sm table-hover table-bordered dosis trxt-m'>
                <thead>
                    <tr className='nowrap'>
                        <th className='text-start ps-2 bg-white-gradient-left stick-col' style={{ minWidth: '100px' }}>Flor varidad color</th>
                        <th className='text-center' style={{ minWidth: '80px' }}>Sem. siembra</th>
                        <th className='text-center' style={{ minWidth: '80px' }}>Desfase</th>
                        <th className='text-center' style={{ minWidth: '80px' }}>S {p.type === 'aclimatacion' ? 'Aclimatación' : 'Consolidación'}</th>
                        <th className='text-center' style={{ minWidth: '80px' }}>S trasplante</th>
                        <th className='text-center' style={{ minWidth: '80px' }}>S corte</th>
                        {p.type !== 'aclimatacion' && <th className='text-center' style={{ minWidth: '100px' }}>Ejecución de siembra</th>}
                        <th className='text-l text-center' style={{ width: p.type !== 'aclimatacion' ? '250px' : '320px' }}>
                            <div className='p-0 m-0' style={{ width: p.type !== 'aclimatacion' ? '250px' : '320px' }}>
                                <div className='w-100 m-0 p-0 text-s text-floricents text-center'>Totales</div>
                                <div className='row justify-content-evenly m-0 p-0 w-100 text-s'>
                                    <div className='w-60 m-0 p-0 text-center'>Plan</div>
                                    <div className='w-40 m-0 p-0 text-center'>Ejecución</div>
                                </div>
                            </div>
                        </th>
                        {p.type !== 'aclimatacion' && <th className='text-center text-s nowrap'>Gm. consolidación</th>}
                        {
                            p.type !== 'aclimatacion' && dias.map((d, i) =>
                                <th key={d + i} style={{ width: '200px' }}>
                                    <div className='text-s row justify-content-evenly m-0 p-0 round-xs text-center' style={{ width: '200px' }}>
                                        <div className='text-center ps-1 pe-1 text-floricents '>{d}</div>
                                        <div className='m-0 p-0 text-center' style={{ width: "33%", borderRight: "solid #90A8B7 1px" }}>
                                            Ejc. Siem.
                                        </div>
                                        <div className='m-0 p-0 text-center' style={{ width: "33%", borderRight: "solid #90A8B7 1px" }}>
                                            Plan
                                        </div>
                                        <div className='m-0 p-0 text-center' style={{ width: "33%" }}>
                                            Realizado
                                        </div>
                                    </div>
                                </th>

                            )
                        }
                        <th className='text-center nowrap'>Hist. cambio</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        p.data.map((dt, i) =>
                            <tr key={'datarr ' + i} className={`nowrap relative ${dt.concluido === 1 ? 'opacity-50 text-bold' : ''}`} >
                                <th className='text-m bg-white-gradient-left stick-col'>{dt.bloque}</th>

                                <td className='text-m text-center'>{dt.semana_siembra}</td>
                                <td className={'text-m text-center ' + (diferencia(p) > 0 ? "rosa-retrasado border border-white" : "")}>{diferencia(p)}</td>
                                <td className='text-m text-center text-bold'>{dt.semana_actual}</td>
                                <td className='text-m text-center'>{dt.transplante}</td>
                                <td className='text-m text-center'>{dt.semanaCosecha}</td>
                                {p.type !== 'aclimatacion' && <td className='text-m text-center'>
                                    {dt.total_ejecutado_charolas} <span className='text-s ms-1'>ch.</span>
                                </td>}
                                <td className='text-m text-center p-0 ' style={{ width: p.type !== 'aclimatacion' ? '250px' : '320px' }}> {totales_bloque(dt)}</td>
                                {p.type !== 'aclimatacion' && <td className='bw-100 p-1 m-0 text-center'>
                                    <input type='number'
                                        className='form-control form-control-sm m-0 p-0 text-center'
                                        min={0}
                                        max={1}
                                        step={0.1}
                                        value={dt.germinacion_consolidacion}
                                        onChange={(e) => { cambiarGermiancion(i, e.target.value) }} id={`input${i}`}
                                        disabled={p.germinacion_consolidacion <= 0 || dt.concluido === 1} />
                                </td>}
                                {
                                    p.type !== 'aclimatacion' && dias.map((d, j) =>
                                        <th key={j + d + i} className='text-s text-center nowrap' style={{ borderLeft: "solid black 0.5px" }}>
                                            <div className='row justify-content-evenly m-0 p-0 round-xs' style={{ width: '200px', border: "solid #D8E5EE 1px" }}>
                                                <div className='col-auto text-400' style={{ width: "33%", borderRight: "solid #90A8B7 1px" }}>
                                                    {dt[d]}
                                                </div>

                                                <div className='m-0 p-0' style={{ width: "33%", borderRight: `solid #90A8B7 1px` }}>
                                                    <input type='number'
                                                        min={0}
                                                        onChange={(e) => { addInfo(e, i, 'p', j) }}
                                                        className={`form-control form-control-sm text-s round-xs border ${+dt.germinacion_real === 0 ? 'text-danger' : ''} ${dt.aclimatado ? "dosis text-bold" : ""}`}
                                                        value={dt[`${dias[j]}p`]}
                                                        placeholder=''
                                                        disabled={dt.aclimatado || +dt.germinacion_real === 0 || dt.concluido === 1} />
                                                </div>

                                                <div className='m-0 p-0 ' style={{ width: "33%" }}>
                                                    <input type='number'
                                                        min={0}
                                                        value={dt[`${dias[j]}e`]}
                                                        onChange={(e) => { agregar_cambio_ejecutado(i, `${dias[j]}e`, e.target.value) }}
                                                        className={`form-control form-control-sm text-s round-xs ${dt.aclimatado ? "dosis text-bold" : ""}`}
                                                        placeholder=''
                                                        disabled={dt.aclimatado || dt.germinacion_consolidacion <= 0 || dt.concluido === 1}
                                                    />
                                                </div>

                                            </div>
                                        </th>
                                    )
                                }
                                {
                                    p.type === 'aclimatacion' && <td className='text-m text-center'>
                                        <button className={'btn btn-sm pt-0 pb-0 ' + (dt.aclimatado ? "btn-warning shadow-sm text-bold ps-5 pe-5" : "btn-light shadow  ps-5 pe-5")}
                                            onClick={() => { cehck(i, 'aclimatacion') }}
                                            disabled={total_ejecutado(dt) <= 0 || dt.concluido === 1}
                                        >{dt.aclimatado ? "Listo" : "No"}</button>
                                    </td>
                                }
                                <td className={`text-center contenedor ${dt.history.length > 0 ? " pointer scale-1" : " opacity-40"}`} onClick={() => {
                                    if (dt.history.length == 0) return;
                                    mostrarHistorial(dt.history);
                                }} >
                                    <img src={historial} className={`${dt.history.length > 0 ? " pointer scale-1" : " opacity-40"}`}
                                        style={{ height: "18px", width: "auto" }}
                                        title="Detalles del registro"
                                    />
                                    <div className='col-auto m-0 p-0 contenedor'>({dt.history.length})</div>

                                    {/*<button className='btn btn-sm round-xxs btn-light shadow scale-1 m-0 pt-0 pb-0' onClick={() => { mostrar_ocultar_detalles(p.id) }}>Detalles</button>*/}
                                </td>
                            </tr>
                        )
                    }

                </tbody>
            </table>}
            {showHistory && <HistorialEstados cerrar={() => { setshowHistory(false); sethistory([]); }} data={[...history]} />}
        </div >
    )
}

export default Reporte_aclimatacion_consolidacion;